export const Headers = [
    'Program Number', 'Program Name', 'Program Type', 'Product Name', 'Receipt Nr', 'Patient ID', 'Events Reported', 'Country', 'Received Date'
];

export const HistroyHeaders = [
    'Program Number', 'Program Name', 'Program Type', 'Product Name', 'Receipt Nr', 'Patient ID', 'Events Reported', 'Country', 'Received Date'
];
